import moment from "moment";

export const columns = [
  {
    accessorKey: "sNo",
    header: "Sr No.",
    size: 80,
    accessorFn: (_row: any, index: number) => index + 1,
  },
  {
    accessorKey: "action",
    header: "Action",
    size: 110,
    accessorFn: () => " ",
  },
  { accessorKey: "billNumber", header: "BL Number", size: 150 },
  { accessorKey: "virNo", header: "VIR #", size: 200 },
  { accessorKey: "containerNo", header: "Container No", size: 160 },
  { accessorKey: "outContainerNo", header: "Out Container No", size: 160 },
  { accessorKey: "chassisNumbers", header: "Chassis Number", size: 180 },
  { accessorKey: "indexNo", header: "Index No", size: 120 },
  { accessorKey: "indexStatus", header: "Index Status", size: 130 },
  { accessorKey: "igmoStatus", header: "IGMO Status", size: 130 },
  {
    accessorKey: "createdAt",
    header: "Created At",
    size: 170,
    accessorFn: (row: any) =>
      row.createdAt ? moment(new Date(row.createdAt)).format("DD-MM-YYYY HH:mm") : "",
  },
  {
    accessorKey: "checkedOutAt",
    header: "Checked Out At",
    size: 170,
    accessorFn: (row: any) =>
      row.checkedOutAt ? moment(new Date(row.checkedOutAt)).format("DD-MM-YYYY HH:mm") : "",
  },
  { accessorKey: "vehicleNumber", header: "Vehicle Number", size: 150 },
  { accessorKey: "nlcSealNumber", header: "NLC Seal Number", size: 150 },
  { accessorKey: "weightToBeOut", header: "Weight To Be Out", size: 150 },
];
